"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ClassroomIcon = /*#__PURE__*/function (_React$Component) {
  function ClassroomIcon() {
    _classCallCheck(this, ClassroomIcon);
    return _callSuper(this, ClassroomIcon, arguments);
  }
  _inherits(ClassroomIcon, _React$Component);
  return _createClass(ClassroomIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "clipboard-icon icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 197 197"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fillRule: "evenodd"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fillRule: "nonzero",
        d: "M49 0h99c27.062 0 49 21.938 49 49v99c0 27.062-21.938 49-49 49H49c-27.062 0-49-21.938-49-49V49C0 21.938 21.938 0 49 0Zm0 20c-16.016 0-29 12.984-29 29v99c0 16.016 12.984 29 29 29h99c16.016 0 29-12.984 29-29V49c0-16.016-12.984-29-29-29H49Z"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        width: "123",
        height: "21.636",
        x: "37",
        y: "45",
        rx: "9"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        width: "123",
        height: "21.636",
        x: "37",
        y: "87.909",
        rx: "9"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        width: "123",
        height: "21.636",
        x: "37",
        y: "129.364",
        rx: "9"
      }))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(ClassroomIcon);